import { Tabs as RadixTabs } from '@radix-ui/themes'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

type TabsSize = '1' | '2'
type TabsJustify = 'start' | 'center' | 'end'
type TabsWrap = 'nowrap' | 'wrap' | 'wrap-reverse'

type TabsRootProps = ComponentPropsWithoutRef<typeof RadixTabs.Root>
type TabsListProps = ComponentPropsWithoutRef<typeof RadixTabs.List> & {
  size?: TabsSize
  justify?: TabsJustify
  wrap?: TabsWrap
}
type TabsTriggerProps = ComponentPropsWithoutRef<typeof RadixTabs.Trigger>
type TabsContentProps = ComponentPropsWithoutRef<typeof RadixTabs.Content>

const TabsRoot = forwardRef<HTMLDivElement, TabsRootProps>((props, ref) => {
  return <RadixTabs.Root ref={ref} {...props} />
})

TabsRoot.displayName = 'Tabs.Root'

const TabsList = forwardRef<HTMLDivElement, TabsListProps>(
  ({ size = '2', justify = 'start', wrap = 'nowrap', ...props }, ref) => {
    return (
      <RadixTabs.List
        justify={justify}
        ref={ref}
        size={size}
        wrap={wrap}
        {...props}
      />
    )
  }
)

TabsList.displayName = 'Tabs.List'

const TabsTrigger = forwardRef<HTMLButtonElement, TabsTriggerProps>(
  (props, ref) => {
    return <RadixTabs.Trigger ref={ref} {...props} />
  }
)

TabsTrigger.displayName = 'Tabs.Trigger'

const TabsContent = forwardRef<HTMLDivElement, TabsContentProps>(
  (props, ref) => {
    return <RadixTabs.Content ref={ref} {...props} />
  }
)

TabsContent.displayName = 'Tabs.Content'

export const Tabs = {
  Root: TabsRoot,
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent
}
